import React from "react";
import { useHistory } from "react-router-dom";
import { isExternalLink } from "../../helpers/helpers.js";

const FooterRedirectBtn = ({ label, url, customClass = "" }) => {
  const history = useHistory();

  const handleNavigation = () => {
    // Check if the URL is external
    const isExternal = isExternalLink(url);

    isExternal
      ? window.open(url, "_blank", "noopener noreferrer")
      : history.push(url); // Navigate externally or internally
  };

  return (
    <button className={customClass} onClick={handleNavigation}>
      {label}
    </button>
  );
};

export default FooterRedirectBtn;
